import { Button, ReviewUnit } from "@onegovbugs/onegov-react-components";
import styles from "./ReviewApplication.module.scss";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { saveApplication } from "../../../redux/actions";
import {
  RedirectIfCaptchaNotSelected,
  RedirectIfAllSectionAreNotCompleted,
} from "../../../utils/Redirect";
import ScrollToTop from "../../../utils/ScrollToTop";
import { format2FAAddress } from "../../../utils/FormatHelper";

const ReviewApplication = (props) => {
  RedirectIfCaptchaNotSelected(props);
  RedirectIfAllSectionAreNotCompleted(props);

  ScrollToTop();

  const dispatch = useDispatch();

  const twoFA = useSelector((state) => state.twoFA);
  const classDetail = useSelector((state) => state.referenceDataDetail);
  const applicantDetails = useSelector((state) => state.personalDetails);
  const qualifications = useSelector((state) => state.qualificationDetail);
  const organisationDetails = useSelector((state) => state.organisationDetail);
  const projectDetails = useSelector((state) => state.projectDetail);
  const locationDetail = useSelector((state) => state.locationDetail);
  const focusOfWorkDetail = useSelector((state) => state.focusOfWorkDetail);
  const associates = useSelector((state) => state.associateDetail);
  const documents = useSelector((state) => state.documentDetail);

  const [twoFAData] = useState(
    twoFA
      ? twoFA.data
      : { firstName: "", lastName: "", day: "", month: "", year: "" }
  );
  const [contactPart] = useState(
    applicantDetails
      ? {
          emailAddress: applicantDetails.emailAddress,
          mobileNo: applicantDetails.mobileNumber,
          phoneNo: applicantDetails.dayTimeTelephoneNumber,
        }
      : { emailAddress: "", mobileNo: "", phoneNo: "" }
  );
  const [classList] = useState(
    classDetail ? classDetail.selectedClasses : null
  );
  const [addressResidential] = useState(
    applicantDetails ? applicantDetails.address : null
  );
  const [addressPostal] = useState(
    applicantDetails ? applicantDetails.secondaryAddress : null
  );
  const [sameAsResidentialFlag] = useState(
    applicantDetails &&
      typeof applicantDetails.isSameAsPrimaryAddress === "boolean"
      ? applicantDetails.isSameAsPrimaryAddress
      : false
  );
  const [qualificationList] = useState(
    qualifications ? qualifications.qualificationList : []
  );
  const [organisationDetail] = useState(
    organisationDetails ? organisationDetails : ""
  );
  const [addressBusiness] = useState(
    organisationDetails ? organisationDetails.businessAddress : null
  );
  const [addressBusinessPostal] = useState(
    organisationDetails ? organisationDetails.postalAddress : null
  );
  const [projectDetail] = useState(projectDetails ? projectDetails : "");
  const [locationList] = useState(
    locationDetail && locationDetail.locationList
      ? locationDetail.locationList.map((on) => ({ ...on }))
      : []
  );
  const [focusOfWorkList] = useState(
    focusOfWorkDetail && focusOfWorkDetail.focusOfWorkList
      ? focusOfWorkDetail.focusOfWorkList.map((on) => ({ ...on }))
      : []
  );

  const [associateList] = useState(
    associates && associates.associateList
      ? associates.associateList.map((on) => ({ ...on }))
      : []
  );
  const [filesAttached] = useState(
    documents ? JSON.parse(documents.documentList) : []
  );

  const [poiFilesAttached] = useState(
    documents ? JSON.parse(documents.poiDocumentList) : []
  );

  //Logic to get Addresses
  const getAddress = (address, addressType, sameAsResidentialFlag) => {
    if (address && address.addressNotChanged === false) {
      if (address && address.enterManually && !address.international) {
        return `${address.addressLine}, ${address.suburb}, ${address.state.label}, ${address.postcode}`;
      } else if (address && address.lookupValue && address.lookupValue.label) {
        return address.lookupValue.label;
      } else {
        return `${address.addressLine}, ${address.suburb}, ${
          address.state ? address.state + "," : ""
        } ${address.postcode}, ${address.country}`;
      }
    } 
    else if (sameAsResidentialFlag && addressType === "Postal"){
      return format2FAAddress(twoFAData.addressses, "Residential");
    }
    else {
      return format2FAAddress(twoFAData.addressses, addressType);
    }
  };

  const jsxClassDetail = (
    <ReviewUnit
      title={"Class Selection"}
      onEdit={() => props.history.push("/flora-fauna/class-detail")}
    >
      {classList.length == 0 ? (
        <div className={`row ${styles.infoLine}`}>
          <div className={"col-12 col-md-6"}>No Class detail</div>
        </div>
      ) : (
        classList.map((el, i) => (
          <div key={"class-" + i}>
            <div className={`row ${styles.infoLine}`}>
              <div className={"col-12 col-md-6"}>
                <div>{el}</div>
              </div>
            </div>
          </div>
        ))
      )}
    </ReviewUnit>
  );

  const jsxApplicantDetail = (
    <ReviewUnit
      title={"Applicant Details"}
      onEdit={() => props.history.push("/flora-fauna/applicant-detail")}
    >
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Title</em>
          </div>
          <div>{applicantDetails.title.label}</div>
        </div>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Full name</em>
          </div>
          <div className={styles.camelCase}>
            {(twoFAData ? twoFAData.firstName : "") +
              " " +
              (twoFAData ? twoFAData.lastName : "")}
          </div>
        </div>
      </div>
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Date of Birth</em>
          </div>
          <div>
            {twoFAData
              ? twoFAData.day + "/" + twoFAData.month + "/" + twoFAData.year
              : ""}
          </div>
        </div>

        <div className={"col-12 col-md-6"}>
          <div>
            <em>Email</em>
          </div>
          <div>{contactPart.emailAddress}</div>
        </div>
      </div>
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Mobile Number</em>
          </div>
          <div>{contactPart.mobileNo}</div>
        </div>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Daytime Telephone Number</em>
          </div>
          <div>{applicantDetails.dayTimeTelephoneNumber}</div>
        </div>
      </div>
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Residential Address</em>
          </div>
          <div>{getAddress(addressResidential, "Residential", sameAsResidentialFlag)}</div>
        </div>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Postal Address</em>
          </div>
          <div>{getAddress(addressPostal, "Postal", sameAsResidentialFlag)}</div>
        </div>
      </div>
    </ReviewUnit>
  );

  const jsxQualifications = (
    <ReviewUnit
      title={"Qualifications"}
      onEdit={() => props.history.push("/flora-fauna/qualification")}
    >
      {qualificationList.length == 0 ? (
        <div className={`row ${styles.infoLine}`}>
          <div className={"col-12 col-md-6"}>No qualification detail</div>
        </div>
      ) : (
        qualificationList.map((el, i) => (
          <div key={"qualification-" + i}>
            {i != 0 && <hr className={styles.hrEmployment} />}
            <div className={`row ${styles.infoLine}`}>
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Course Name</em>
                </div>
                <div>{el.courseName}</div>
              </div>
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Issuing Authority</em>
                </div>
                <div>{el.issuingAuthority}</div>
              </div>
            </div>
            <div className={`row ${styles.infoLine}`}>
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Certificate Date</em>
                </div>
                <div>
                  {el.dayOfCertificateDate}/{el.monthOfCertificateDate}/
                  {el.yearOfCertificateDate}
                </div>
              </div>
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Certificate Name</em>
                </div>
                <div>{el.certificateName}</div>
              </div>
            </div>
            <div className={`row ${styles.infoLine}`}>
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Institution Name</em>
                </div>
                <div>{el.institutionName}</div>
              </div>
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Details</em>
                </div>
                <div>{el.details}</div>
              </div>
            </div>
          </div>
        ))
      )}
    </ReviewUnit>
  );

  const jsxAssociates = (
    <ReviewUnit
      title={"Associates"}
      onEdit={() => props.history.push("/flora-fauna/associate")}
    >
      {associateList.length == 0 ? (
        <div className={`row ${styles.infoLine}`}>
          <div className={"col-12 col-md-6"}>No associate detail</div>
        </div>
      ) : (
        associateList.map((el, i) => (
          <div key={"associates-" + i}>
            {i != 0 && <hr className={styles.hrEmployment} />}
            <div className={`row ${styles.infoLine}`}>
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Title</em>
                </div>
                <div>{el.title.label}</div>
              </div>
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Full Name</em>
                </div>
                <div>
                  {" "}
                  {el.firstName} {el.middleName} {el.lastName}
                </div>
              </div>
            </div>
            <div className={`row ${styles.infoLine}`}>
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Daytime Phone Number</em>
                </div>
                <div>{el.dayTimePhoneNumber}</div>
              </div>
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Mobile Number</em>
                </div>
                <div>{el.mobileNumber}</div>
              </div>
            </div>
            <div className={`row ${styles.infoLine}`}>
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Email</em>
                </div>
                <div>{el.email}</div>
              </div>
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Date Of Birth</em>
                </div>
                <div>
                  {el.dayOfBirth}/{el.monthOfBirth}/{el.yearOfBirth}
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </ReviewUnit>
  );
  const jsxOrganisationDetail = (
    <ReviewUnit
      title={"Organisation Detail"}
      onEdit={() => props.history.push("/flora-fauna/organisation")}
    >
      {organisationDetail.hasOrganisation === "no" ? (
        <div className={`row ${styles.infoLine}`}>
          <div className={"col-12 col-md-6"}>No organisation detail</div>
        </div>
      ) : (
        <>
          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>ABN</em>
              </div>
              <div>{organisationDetail.abn}</div>
            </div>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>ACN</em>
              </div>
              <div>{organisationDetail.acn}</div>
            </div>
          </div>
          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Name of Organisation</em>
              </div>
              <div>{organisationDetail.organisationBusinessName}</div>
            </div>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Web Address</em>
              </div>
              <div>{organisationDetail.webAddress}</div>
            </div>
          </div>
          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Daytime Phone Number</em>
              </div>
              <div>{organisationDetail.dayTimePhoneNumber}</div>
            </div>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Email Address</em>
              </div>
              <div>{organisationDetail.email}</div>
            </div>
          </div>
          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Business Address</em>
              </div>
              <div>{getAddress(addressBusiness, "Business")}</div>
            </div>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Postal Address</em>
              </div>
              <div>{getAddress(addressBusinessPostal, "Postal")}</div>
            </div>
          </div>
        </>
      )}
    </ReviewUnit>
  );

  const jsxProjectDetail = (
    <ReviewUnit
      title={"Project Details"}
      onEdit={() => props.history.push("/flora-fauna/project-detail")}
    >
      {projectDetail === null ? (
        <div className={`row ${styles.infoLine}`}>
          <div className={"col-12 col-md-6"}>No project detail</div>
        </div>
      ) : (
        <>
          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Title</em>
              </div>
              <div>{projectDetail.title}</div>
            </div>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Objective</em>
              </div>
              <div>{projectDetail.objective}</div>
            </div>
          </div>
          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Project Equipment and Method</em>
              </div>
              <div>{projectDetail.equipment}</div>
            </div>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Project End Date</em>
              </div>
              <div>
                {projectDetail.dayOfProjectEndDate}/
                {projectDetail.monthOfProjectEndDate}/
                {projectDetail.yearOfProjectEndDate}
              </div>
            </div>
          </div>
        </>
      )}
    </ReviewUnit>
  );
  console.log(locationList);
  const jsxLocationData = (
    <ReviewUnit
      title={"Location Data"}
      onEdit={() => props.history.push("/flora-fauna/location")}
    >
      {locationList.map((el, i) => (
        <div key={"loc-" + i}>
          {i != 0 && <hr className={styles.hrEmployment} />}
          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Tenure Type</em>
              </div>
              <div>{el.tenureType.value}</div>
            </div>
            {el.locationSearch.value && (
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Branch / Region / Area / Park</em>
                </div>
                <div>{el.locationSearch.value}</div>
              </div>
            )}
            {el.lga.value && (
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>LGA</em>
                </div>
                <div>{el.lga.value}</div>
              </div>
            )}
            {el.lls.value && (
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>LLS</em>
                </div>
                <div>{el.lls.value}</div>
              </div>
            )}
            {el.karstArea.value && (
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Karst Area</em>
                </div>
                <div>{el.karstArea.value}</div>
              </div>
            )}
            {el.marinePark.value && (
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Marine Park</em>
                </div>
                <div>{el.marinePark.value}</div>
              </div>
            )}
            {el.stateForest.value && (
              <div className={"col-12 col-md-6"}>
                <div>
                  <em>State Forest</em>
                </div>
                <div>{el.stateForest.value}</div>
              </div>
            )}
          </div>

          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Other</em>
              </div>
              <div>{el.other}</div>
            </div>
          </div>
        </div>
      ))}
    </ReviewUnit>
  );

  const jsxFocusOfWork = (
    <ReviewUnit
      title={"Focus Of Work"}
      onEdit={() => props.history.push("/flora-fauna/focusofwork")}
    >
      {focusOfWorkList.map((el, i) => (
        <div key={"loc-" + i}>
          {i != 0 && <hr className={styles.hrEmployment} />}
          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Species Type</em>
              </div>
              <div>{el.speciesType}</div>
            </div>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Family / Genus / Species / SubSpecies</em>
              </div>
              <div>{el.speciesSearch.label}</div>
            </div>
          </div>
          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Target Parts</em>
              </div>
              <div>{el.targetPart.value}</div>
            </div>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>No Of Target Parts</em>
              </div>
              <div>{el.targetPartNumber}</div>
            </div>
          </div>
          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Common Name</em>
              </div>
              <div>{el.commonName.label}</div>
            </div>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Sample Units</em>
              </div>
              <div>{el.sampleUnit.value}</div>
            </div>
          </div>
        </div>
      ))}
    </ReviewUnit>
  );

  const jsxAttachments = (
    <>
      <ReviewUnit
        title={"Attachments"}
        onEdit={() => props.history.push("/flora-fauna/upload-document")}
      >
        <div className={`row ${styles.infoLine}`}>
          <div className={"col-12"}>
            <div>
              <em>Additional Document Attachments</em>
            </div>
            {filesAttached.map((el, i) => (
              <div className={styles.fileList} key={"attachment-" + i}>
                {i > 0 && (
                  <>
                    <br />
                    <hr />
                    <br />
                  </>
                )}
                <p>{el.attachmentType}</p>
                <p>{el.name}</p>
                <p>{el.description}</p>
              </div>
            ))}
            {filesAttached.length == 0 && <p>No attachment attached</p>}
            <br/>
            <div>
              <em>Proof of Identity Attachments</em>
            </div>
            {poiFilesAttached.map((el, i) => (
              <div className={styles.fileList} key={"attachment-" + i}>
                {i > 0 && (
                  <>
                    <br />
                    <hr />
                    <br />
                  </>
                )}
                <p>{el.attachmentType}</p>
                <p>{el.name}</p>
                <p>{el.description}</p>
              </div>
            ))}
            {poiFilesAttached.length == 0 && <p>No Proof of Identity attachment attached</p>}
          </div>
        </div>
      </ReviewUnit>
    </>
  );

  return (
    <div className={styles.mainCont}>
      <p>
        Please check the information you have entered in this application. If
        you need to correct any of the details, click 'Back' or select the
        relevant section and change the information as appropriate. To proceed
        with the application click 'Next'.
      </p>

      {jsxClassDetail}
      {jsxApplicantDetail}
      {jsxQualifications}
      {jsxAssociates}
      {jsxOrganisationDetail}
      {jsxProjectDetail}
      {jsxLocationData}
      {jsxFocusOfWork}
      {jsxAttachments}
      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              dispatch(
                saveApplication("step9", () => {
                  props.history.push(`./declaration`);
                })
              );
            }}
          >
            Confirm
          </Button>
          <Button
            secondary
            onClick={() => {
              dispatch(
                saveApplication("step9", () => {
                  props.history.push(`../flora-fauna/dashboard`);
                })
              );
            }}
          >
            Save & exit section
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <ReviewApplication {...props} />);
